import {
  FETCH_RESTAURANT_PAYMENTS,
  FETCH_OVERDUE_PAYMENTS,
  CLEAR_RESTAURANT_PAYMENTS
} from "../actions/actionTypes";

import { convertArrayToMap } from "../helpers/utils"

const defaultState = {
  //mapa z płatnościami o przekroczonym terminie płatności - klucz ID restauracji, wartość tablica z przekroczonymi płatnościami dla tej restauracji
  overduePaymentMap: new Map(),
  //lista ze wszystkimi płatnościami wybranej restauracji
  restaurantPaymentList: []
};

export default function paymentReducer(state = defaultState, action) {
  switch (action.type) {
    case FETCH_RESTAURANT_PAYMENTS: {
      return {
        ...state,
        restaurantPaymentList: action.payload
      };
    }
    case FETCH_OVERDUE_PAYMENTS: {
      return {
        ...state,
        overduePaymentMap: convertArrayToMap(action.payload, 'licencjaFlow')
      };
    }
    case CLEAR_RESTAURANT_PAYMENTS: {
      return {
        ...state,
        restaurantPaymentList: []
      };
    }
    default:
      return state;
  }
}
